// extracted by mini-css-extract-plugin
export default {"root":"ErrorCase_root__Cqbc-","title":"ErrorCase_title__khlEf","text":"ErrorCase_text__11kIa","textAccent":"ErrorCase_textAccent__F5-q4"};